import _classof from "../internals/classof";
var exports = {};
var classof = _classof;
exports = function (it) {
  var klass = classof(it);
  return klass === "BigInt64Array" || klass === "BigUint64Array";
};
export default exports;